import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiUserPlus, FiUserMinus, FiHeart, FiChevronRight } from 'react-icons/fi';

const Registrations = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  const registrationList = [
    {
       title: "जन्म नोंदणी",
       icon: <FiUserPlus className="w-5 h-5" />
    },
    {
        title: "मृत्यू नोंदणी",
        icon: <FiUserMinus className="w-5 h-5" />
    },
    {
        title: "विवाह नोंदणी",
        icon: <FiHeart className="w-5 h-5" />
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8 font-poppins">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col md:flex-row justify-between items-center bg-[#267c77] text-white">
          <div>
            <h1 className="text-3xl font-bold mb-2">नोंदणी</h1>
            <p className="text-orange-100">
               {grampanchayatName ? `${grampanchayatName} | ` : ''} 
               {arthikVarshLabel ? `आर्थिक वर्ष: ${arthikVarshLabel}` : ''}
            </p>
          </div>
          <button 
           onClick={() => navigate('/asthapan-dashboard', { state: location.state })}
            className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm"
          >
            मागे जा
          </button>
        </div>
      </div>

      {/* Registrations Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {registrationList.map((item, index) => (
          <div 
            key={index}
            className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 p-6 border-l-4 border-[#267c77] cursor-pointer group flex items-center justify-between"
            onClick={() => {
              if (item.title === "जन्म नोंदणी") {
                navigate('/asthapan/registrations/birth', { state: location.state });
              } else if (item.title === "मृत्यू नोंदणी") {
                navigate('/asthapan/registrations/death', { state: location.state });
              } else if (item.title === "विवाह नोंदणी") {
                navigate('/asthapan/registrations/marriage', { state: location.state });
              } else {
                 console.log(`Selected: ${item.title}`);
              }
            }}
          >
             <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#267c77]/10 flex items-center justify-center text-[#267c77] group-hover:bg-[#267c77] group-hover:text-white transition-colors duration-300">
                    {item.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-800 group-hover:text-[#267c77] transition-colors">
                {item.title}
                </h3>
             </div>
             <FiChevronRight className="text-gray-400 group-hover:text-[#267c77] transform group-hover:translate-x-1 transition-all" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Registrations;
